import React, { Fragment } from "react";
import Countdown, { doubleDigit } from "react-downcount";
import ReactWOW from "react-wow";
// https://skyvow.github.io/react-wow/#/
// https://www.pexels.com/search/programming/

const endDate = new Date("March 13 2020 00:00:00 GMT+08:00");
// const endDate = "1569887999000";

const customRenderer = ({ days, hrs, mins, secs, isCompleted }) => {
  return isCompleted ? (
    ""
  ) : (
    <Fragment>
      <div className="segment">
        <span className="number">{days}</span>
        <span className="unit">days</span>
      </div>
      <div className="segment">
        <span className="number">{hrs}</span>
        <span className="unit">hours</span>
      </div>
      <div className="segment">
        <span className="number">{doubleDigit(mins)}</span>
        <span className="unit">min</span>
      </div>
      <div className="segment">
        <span className="number">{doubleDigit(secs)}</span>
        <span className="unit">sec</span>
      </div>
    </Fragment>
  );
};

class Hero extends React.Component {
  goRegister() {
    const target = document.getElementById("register");
    target.scrollIntoView({ block: "start", behavior: "smooth" });
  }
  render() {
    return (
      <section
        id="hero"
        style={{ backgroundImage: "url(images/section-background-03.png)" }}
      >
        <div className="container">
          <img
            src="images/hero-image.png"
            alt="Best Coder Challenge logo"
            className="hero-image"
          />
          <div
            className="hero-circle"
            style={{
              backgroundImage: "url(images/hero-background-circle.png)"
            }}
          ></div>
          {/* <ReactWOW animation="bounceInLeft" delay="0.3s">
            <p className="date">13 March 2020</p>
          </ReactWOW> */}
          <ReactWOW animation="bounceInLeft" delay="0.4s">
            <p className="desc">
              THE LARGEST <span>DATA ANALYTICS</span> COMPETITION IN SINGAPORE
            </p>
          </ReactWOW>
          <a
            href="https://techatshopee.formstack.com/forms/bestcodercampus2020"
            className="btn btn-primary"
          >
            Register Now
          </a>

          <ReactWOW animation="bounceInLeft" delay="0.4s">
            <p className="register">
              {/* Registration will close on 23 February 2020 (2359 SGT) or when
              maximum capacity has been reached.
              <br /> */}
              Successfully registered teams will receive a confirmation email.
            </p>
          </ReactWOW>

          {/* <ReactWOW animation="bounceInLeft" delay="0.5s">
            <Countdown className="countdown" endDate={endDate}>
              {customRenderer}
            </Countdown>
            <span className="countDesc">
              To the start of I’m the Best Coder! Challenge Campus Edition 2020
            </span>
          </ReactWOW> */}
        </div>
      </section>
    );
  }
}

export default Hero;
